//#region src/shared/overflow/constants.ts
var e = "data-overflowing", t = "data-overflow-item", n = "data-overflow-menu", r = ({ item: t, visible: n }) => {
	n ? t.element.removeAttribute(e) : t.element.setAttribute(e, "");
};
//#endregion
export { e as DATA_OVERFLOWING, t as DATA_OVERFLOW_ITEM, n as DATA_OVERFLOW_MENU, r as updateVisibilityAttribute };
